var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93301 6.75C4.74056 7.08333 4.25944 7.08333 4.06699 6.75L1.0359 1.5C0.843448 1.16667 1.08401 0.750001 1.46891 0.750001L7.53109 0.75C7.91599 0.75 8.15655 1.16667 7.9641 1.5L4.93301 6.75Z",
    fill: "#1D2433"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidDownArrow);
export default __webpack_public_path__ + "static/media/SolidDownArrow.60aaa5f22bc2641b468c7227ed881e2d.svg";
export { ForwardRef as ReactComponent };